import { render, staticRenderFns } from "./RocketShip.vue?vue&type=template&id=2573a13a&"
import script from "./RocketShip.vue?vue&type=script&lang=js&"
export * from "./RocketShip.vue?vue&type=script&lang=js&"
import style0 from "./RocketShip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports